import { Button, Icon, IconColor } from '@/dc-shared-web/src'
import { faCircleCheck } from '@document-crunch/pro-regular-svg-icons'

interface SuccessStateProps {
  documentName?: string
  onClose: () => void
}

/**
 * Success state component for ProjectSight modal
 * Shows a success message after successfully exporting to ProjectSight
 */
export const SuccessState: React.FC<SuccessStateProps> = ({
  documentName,
  onClose,
}) => {
  return (
    <>
      <div
        className='tw-flex tw-flex-col tw-items-center tw-justify-center'
        aria-live='polite'
      >
        <div
          className='tw-w-full tw-bg-success-muted tw-border tw-border-success-border-muted tw-rounded-md tw-p-4'
          role='status'
        >
          <div className='tw-flex tw-items-start'>
            <div className='tw-w-6 tw-h-6 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mr-3 tw-flex-shrink-0'>
              <Icon
                icon={faCircleCheck}
                color={IconColor.success}
                aria-hidden='true'
              />
            </div>
            <div>
              <p className='tw-text-success-foreground tw-font-medium'>
                Export Successful
              </p>
              <p className='tw-text-muted tw-text-xs'>
                {documentName
                  ? `${documentName} successfully exported to your ProjectSight account.`
                  : 'File successfully exported to your ProjectSight account.'}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className='tw-flex tw-justify-end tw-gap-2 tw-mt-3'>
        <Button
          type='button'
          variant='outline'
          onClick={onClose}
          aria-label='Close dialog after successful export'
        >
          Close
        </Button>
      </div>
    </>
  )
}

export default SuccessState
